import Vue from 'vue'
import Mask from './src/main.vue'

// dom上的num属性是用来记录被打开了几个
Mask.install = (propsData) => {
  if (document.querySelector('.integral-mask')) {    // 检测到有就不添加了
    // 如果存在了就累计计数
    let dom = document.querySelector('.integral-mask')
    let num = dom.getAttribute('num') * 1 + 1
    dom.setAttribute('num', num)
    return
  }
  const Masks = Vue.extend(Mask)
  const component = new Masks({propsData: propsData}).$mount()
  component.$el.setAttribute('num', 1)
  document.querySelector('body').style.overflow = 'hidden'
  document.querySelector('body').appendChild(component.$el)
}
// 这是关闭遮罩
// dom上的num属性是用来记录被打开了几个
Mask.install.close = () => {
  let dom = document.querySelector('.integral-mask')
  if (!dom) {
    return
  }
  let num = dom.getAttribute('num') * 1
  
  // 等于1代表只剩余这一个了
  if (num === 1) {
    document.querySelector('body').style.overflow = 'visible'
    dom.style.opacity = 0
    let timmer = setTimeout(() => {
      document.querySelector('body').removeChild(dom)
      clearTimeout(timmer)
    }, 500)
  } else {
    dom.setAttribute('num', --num)
  }
}

export default Mask



// WEBPACK FOOTER //
// ./src/plugin/IntegralMask/index.js